import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 100+ TAKTİK RAPOR YAPAY ZEKÂ KOMUTU™',
  ideal: 'Raporlarını, tutanaklarını ve idari belgelerini daha düzenli hazırlamak isteyen kolluk kuvvetleri personeli, soruşturma görevlileri ve amirler.',
  was: '2.660 TRY',
  now: '1.330',
  features: ['6 Ciltlik Eksiksiz Taktiksel Sistem', 'Avukat Onaylı, Kullanıma Hazır 100’den Fazla Komut (Prompt)', 'Tüm Başlıca Yapay Zekâ Modelleriyle Anında Uyum', '4 Ücretsiz Taktiksel Bonus Dahil', '7 Günlük Risksiz Deneme Garantisi', '♾️ Ömür Boyu Erişim ve Ücretsiz Güncellemeler'],
  cta: 'Ürünü şimdi alın'
};
const trust = [{
  icon: LockIcon,
  label: 'Güvenli ödeme'
}, {
  icon: ZapIcon,
  label: 'Dijital erişim'
}, {
  icon: SmartphoneIcon,
  label: 'Mobil kullanım'
}, {
  icon: CreditCardIcon,
  label: 'Kredi / Banka kartı'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Fiyatlandırma" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-118" data-mp="3vynlio2kwdf5">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-119" data-mp="4rb365pyltxn">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-120" data-mp="er1vq1uylyv3">
          <p className="font-display text-xl font-black text-plum" data-id="element-121" data-mp="eqk27czolyqv">🔥 Sınırlı Teklif — Yakında Sona Eriyor!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-122" data-mp="3d6uqyp7v2k5b">
            ⚠️ Bu sürenin ardından fiyat tekrar 2.660 TRY'ye dönecek. Bu fiyat bir daha geri gelmeyecek.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(29,78,216,0.5)]" data-id="element-123" data-mp="3n525l1eogq45">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-124" data-mp="2mh8m93hy6e4e">
            <h3 className="font-display text-base font-black text-white" data-id="element-125" data-mp="315mmr7rw5qhs">{plan.name}</h3>
          </div>
          <p className="text-sm text-plum/60" data-id="element-126" data-mp="2w8mkl7y5x7vy">
            <span className="font-semibold text-plum/80" data-id="element-127" data-mp="2w9xmt3bym7ky">Kimler için idealdir?</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-128" data-mp="23j5skbegft09">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-129" data-mp="23jz21k4sswm3">{plan.was}</span>
            <div className="flex w-full items-baseline justify-center gap-2 py-2" data-id="element-130" data-mp="2ih7wwntb8iik">
              <span className="text-grape-shine text-[64px] font-black leading-none sm:text-[74px]" style={{
              fontFamily: "Merriweather, serif"
            }} data-id="element-131" data-mp="2dgk5w25301oc">
                {plan.now}
              </span>
              <span className="text-[28px] font-black leading-none text-grape" style={{
              fontFamily: "Merriweather, serif"
            }} data-id="element-132" data-mp="3ows4jshe6suq">
                TRY
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-133" data-mp="59gna33r9lna">
              · Tek seferlik ödeme · Ömür boyu erişim ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-134" data-mp="3ng4rlqqze4rw">
              · Ödeme, yerel para biriminiz üzerinden gerçekleştirilecektir ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-135" data-mp="j1wmestjczix">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-136" data-mp="o07vh1c0b603">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-137" data-mp="a9340mislk0u" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-138" data-mp="e8lpbjeizx47">
            <CTAButton size="md" data-id="element-139" data-mp="11z7nmiyqa310">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-140" data-mp="16qfub78obaah">
            1.330 TRY tasarruf (%50 indirim)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-141" data-mp="3f81scvpcr4oc">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="358t2adxlya79">
                <Icon className="h-4 w-4 text-grape" data-id="element-143" data-mp="317r0pqg7xm24" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-144" data-mp="1rkl7wapfedl">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-145" data-mp="3t103pri6x7dj" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-146" data-mp="3o6nibbx5llz5">
            <span className="font-display font-bold text-plum" data-id="element-147" data-mp="3k74v29hv0yt5">
              🛡️ 7 Günlük Para İade Garantisi.
            </span>{' '}
            Satın aldıktan sonraki ilk yedi gün içinde sistemin ihtiyaçlarınıza uygun olmadığını
            düşünürseniz, açıklanan iade koşulları çerçevesinde geri ödeme talep edebilirsiniz.
          </p>
        </div>
      </div>
    </section>;
}